import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Pagination from '../../../components/Header/Pagination';
import directoryServices from '../directoryServices';

export default function AddImprint(param: any) {    

    let [associatedSubclassification, setassociatedSubclassification] = useState<any>([]);
    let [associatedclassification, setassociatedclassification] = useState<any>([]);
    let [SubClassificationtotalRow, setSubClassificationtotalRow] = useState(1);
    let [listSubClassification, setlistSubClassification] = useState<any>([]);
    let [SubClassificationSearch, setSubClassificationSearch] = useState("");
    let [ClassificationtotalRow, setClassificationtotalRow] = useState(1);
    let [listClassification, setlistClassification] = useState<any>([]);    
    let [ClassificationSearch, setClassificationSearch] = useState(""); 
    let [selectedFile, setSelectedFile] = useState<any>(null);    
    let [saveStatus, setSaveStatus] = useState(false);
    let [EditValue, setEditValue] = useState<any>([]);

    var SubclassFicationPayload = {
        area: "Imprints",
        referenceCode: "",
        text: "",
        pageNumber: 1,
        pagesize: 10
    }

    var pickerColors = [
        '#EF534F', '#C62928', '#980A0B',
        '#BA69C8', '#7B1FA2', '#4A148C',
        '#F57C02', '#E65100',
        '#81C784', '#2F7D31', '#1A5E20',
        '#7FDEEA', '#00838F', '#004D41',
        '#90CAF9', '#029BE5', '#01579B',
        '#DBDBDB', '#000000'
    ];

    let classFicationPayload = {
        formArea: "Imprints",
        pageNumber: 1,
        pagesize: 10,
        useFreeText: ""
    }

    const closePage = () => {
        param.onChangeClose(EditValue);
    }
    
    const handleFileChange = (e: any) => {
        var fileName = e.target.files[0];
        const file = e.target.files && e.target.files[0];
        if (e.target.files) {
            setSelectedFile(file);
            fileName = URL.createObjectURL(fileName);
            setEditValue({ ...EditValue, ...{ labelImage: fileName } });
        }

    }

    const handleNameOnChange = (n: any) => {
        classFicationPayload.pageNumber = n.pageNumber;
        classFicationPayload.pagesize = n.pageSize;
        ClassificationListing()
    }

    const handleNameOnChangeSub = (n: any) => {
        SubclassFicationPayload.pageNumber = n.pageNumber;
        SubclassFicationPayload.pagesize = n.pageSize;
        SubClassificationListing()
    }

    const ClassificationListing = () => {
        if (ClassificationSearch.length > 1) {
            classFicationPayload.useFreeText = ClassificationSearch;
        }
        directoryServices.zFreeTextListing(classFicationPayload).then((res) => {
            setlistClassification(res)
            setClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })
    }

    const ClassificationSave = (e: any) => {

        if (e !== false) {

            directoryServices.musicDirectoryCategorySave({ Code: EditValue.companyName, categoryName: e, categoryType: "Imprints" });
        } else {
            directoryServices.zFreeTextsave({ formArea: "Imprints", useFreeText: ClassificationSearch });
            directoryServices.musicDirectoryCategorySave({ Code: EditValue.companyName, categoryName: ClassificationSearch, categoryType: "Imprints" });
        }
        loadListClassification();
    }

    const SubClassificationListing = () => {

        if (SubClassificationSearch.length > 1) {
            SubclassFicationPayload.text = SubClassificationSearch;
        }
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setlistSubClassification(res)
            setSubClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })
    }

    const SubClassificationSave = (e: any) => {

        if (e !== false) {
            directoryServices.tagSave({ area: e, code: SubClassificationSearch, id: 0, isActive: 1, isCustom: 1, referenceCode: EditValue.companyName, text: e });
        } else {
            directoryServices.tagSave({ area: "Imprints", code: SubClassificationSearch, id: 0, isActive: 1, isCustom: 1, referenceCode: EditValue.companyName, text: SubClassificationSearch });
            //directoryServices.musicDirectoryCategorySave({Code:EditValue.companyName , categoryName:ClassificationSearch,categoryType:"Imprints"} );
        }
        loadListClassification();
    }

    const deleteSubTaging = (e: any) => {
        directoryServices.tagdelete(e).then((res) => {
            SubclassFicationPayload.referenceCode = EditValue.companyName;
            directoryServices.tagListing(SubclassFicationPayload).then((res) => {
                setassociatedSubclassification(res)
            })
        })
    }

    const deleteTaging = (e: any) => {
        directoryServices.musicDirectoryCategoryDelete(e).then((res) => {

            directoryServices.musicDirectoryCategoryListing({ code: EditValue.companyName, CategoryType: "Imprints" }).then((res) => {
                setassociatedclassification(res)
            })
        })
    }

    const SaveAsset = () => {
        console.log(EditValue)
        console.log(selectedFile)

        if(EditValue && EditValue.categoryList){
            delete EditValue.categoryList;
        }

        if(EditValue && EditValue.totalSubRows){
            delete EditValue.totalSubRows;
        }

        directoryServices.imprintSave(selectedFile , EditValue).then( (res) =>{
            console.log(res)
            if(res && (!res.errorCode || !res.ExceptionMessage)){
                setSaveStatus(true)
                EditValue= res;
                loadListClassification();
            }
        })
    }

    const loadListClassification = () => {
        SubclassFicationPayload.referenceCode = EditValue.companyName;
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setassociatedSubclassification(res)
        })

        directoryServices.musicDirectoryCategoryListing({ code: EditValue.companyName, CategoryType: "Imprints" }).then((res) => {
            setassociatedclassification(res)
        })
    }

    useEffect(() => {

        console.log( param);
        console.log( param.selectedDetail);

        if( param && param.selectedDetail && param.selectedDetail.companyName){
            console.log(param.selectedDetail)
            EditValue = param.selectedDetail;
            setEditValue(EditValue)
            loadListClassification();
            setSaveStatus(true)
        }
    }, [param])

    const EditHandler = (e: any) => {
        var field_name = e.target.name;
        var field_value = e.target.value;

        console.log(field_name)
        setEditValue({ ...EditValue, ...{ [field_name]: field_value } });        
    }

    return (
        <><Drawer open={param.open}
            onClose={closePage}
            direction='right'
            className='react-drawer-left allowHscroll allowVscroll'>
            <div className="box ws-6 pull-right allowHscroll allowVscroll full-height-vh">

                <div className="box-header-main"> <h2>New Imprint</h2> </div>

                <div className="box-content box">

                    <div className="form-format ws-12">
                        <label className="control-label text-left">Imprint Name*</label>

                        <div className="label-entries ws-12">
                            <div className="ws-10">
                                <input type="text" id="Contact" name="companyName" onChange={EditHandler}
                                    placeholder="Imprint Name" value={EditValue && EditValue.companyName ? EditValue.companyName  : ''} />
                            </div>
                        </div>
                    </div>

                    {<div className="ws-12 mtl" >
                        <label className="control-label text-left ws-12 mt text-bold">Imprint Image</label>
                        <div className="ws-12 pm mb">
                            <div className="ws-4">

                                {(EditValue.labelImage) && <div className="box shadowCoverPicture shadow">
                                    <div className="coverPicture">
                                        <img src={EditValue.labelImage} />
                                    </div>
                                </div>}

                                {!(EditValue.labelImage) && <table className="box coverPictureContainer shadow">
                                    <tbody><tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <i className="icon-new-registration fullImage"></i>
                                        </td>
                                    </tr></tbody>
                                </table>}
                            </div>


                            <div className="ws-7 pm pull-right">
                                <label className="icon-btn primary" style={{ marginTop: "15%" }}>Upload Image
                                    <input type="file" accept="image/*" id="file-upload" className="hide" onChange={handleFileChange} />
                                </label>

                                <span className="ws-12 mt">Maximum file size 2mb file types accepted .jpg/ .png/ .bmp (Resolution Minimum 300px X 230px).</span>
                            </div>
                        </div>
                    </div>}

                    {(saveStatus) && <div className='ws-12'>
                        {<div className="form-format ws-12 mtl box pLarge" >
                            <label className="control-label text-left">Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={ClassificationSearch} placeholder="Type to search for classification" onChange={(e) => setClassificationSearch(e.target.value)} />
                                </div>

                                <button className="icon-btn edit btn-xs pl pr pts" onClick={() => ClassificationListing()}> <i className="icon-search"></i> </button>
                                
                                {(ClassificationSearch.length > 1) && <div>
                                    <button className="icon-btn edit btn-xs pl pr pts" onClick={() => ClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                    {listClassification?.map((values: any) => {
                                        return (
                                            <tr>
                                                <td width="20%"> <input type="checkbox" onClick={() => ClassificationSave(values.useFreeText)} /> </td>
                                                <td>{values.useFreeText}</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>

                                {(() => {
                                    if (ClassificationtotalRow && ClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChange} totalRows={ClassificationtotalRow} />
                                    }
                                })()}

                            </div>

                            {(associatedclassification.length > 0) && <div className="form-format ws-12 mtl" ng-show="directoryClassifications.length > 0">
                                <label className="control-label text-left w-30 mt">Associated Classification(s):</label>
                                {associatedclassification?.map((values: any, index: any) => {

                                    return (
                                        <div className=''>
                                            <a className="btn ms ps" style={{ background: pickerColors[index], color: "RGB(255,255,255)" }}>
                                                <span className="mts mb text-center" style={{ color: "#fff" }}>{values.categoryName}</span>
                                                <span className="pull-right mtss" onClick={() => deleteTaging(values.creatorCategoryId)}>
                                                    <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                </span>
                                            </a>
                                        </div>
                                    )
                                })}
                            </div>}

                            {(ClassificationtotalRow === 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No classification available  </div>
                            </div>}

                        </div>}

                        {<div className="form-format ws-12 mtl box pLarge">
                            <label className="control-label text-left">Sub Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={SubClassificationSearch} placeholder="Type to search for Sub classification" onChange={(e) => setSubClassificationSearch(e.target.value)} />
                                </div>
                                <div >
                                    <button className="icon-btn edit btn-xs pl pr pts" onClick={() => SubClassificationListing()}>
                                        <i className="icon-search"></i>
                                    </button>
                                </div>
                                {(SubClassificationSearch.length > 1) && <div>
                                    <button className="icon-btn edit btn-xs pl pr pts" onClick={() => SubClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                    {listSubClassification?.map((values: any) => {
                                        return (
                                            <tr>
                                                <td width="20%"> <input type="checkbox" onClick={() => SubClassificationSave(values.code)} /> </td>
                                                <td>{values.code}</td>
                                            </tr>

                                        )
                                    })}

                                    </tbody>

                                </table>

                                {(() => {
                                    if (SubClassificationtotalRow && SubClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChangeSub} totalRows={SubClassificationtotalRow} />
                                    }
                                })()}

                            </div>

                            {(associatedSubclassification.length > 0) && <div className="form-format ws-12 mtl">
                                <label className="control-label text-left w-30 mt ">Associated Sub Classification(s):</label>

                                {
                                    associatedSubclassification?.map((values: any, index: any) => {

                                        return (
                                            <div>
                                                <a className="btn ms ps" style={{ background: pickerColors[index], color: "#fff" }}>
                                                    <span className="mts mb text-center" style={{ color: "#fff" }}>{values.text}</span>
                                                    <span className="pull-right mtss" onClick={() => deleteSubTaging(values.id)}>
                                                        <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                    </span>
                                                </a>
                                            </div>
                                        )
                                    })


                                }
                            </div>}
                            {(SubClassificationtotalRow === 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No Subclassification available</div>
                            </div>}

                        </div>}
                    </div>}

                    <div className="box-footer">
                        <div className="pull-right">
                            <button className="icon-btn edit" onClick={SaveAsset}>
                                <i className="icon-save"></i> Save
                            </button>
                            <button className="icon-btn delete pull-right" onClick={() => closePage()}>
                                <i className="icon-close"></i> Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </Drawer></>
    )
}